import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdatePostTagMutation = createMutationHook(
  MembershipsCreatorApiClient.updatePostTag,
  {
    mutationKey: ['updatePostTag'],
  },
)
